
/* React */
import React, { Component } from 'react';

/* Redux */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withRouter } from 'react-router-dom';
import { actions as ruleActions } from '../../redux/ducks/rule'

/* Routes */
import { domainIsTenant as dit, S, domain } from '../../routes/routes'

/* Result */
import Result from 'iotera-base/result'

import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import EditIcon from '@material-ui/icons/Edit';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import DeleteIcon from '@material-ui/icons/DeleteOutline';

import { SubViewHeaderStep } from '../../lib/components/subHeader';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { Button } from '@material-ui/core';

import { SizeMe } from 'react-sizeme';
import { CustomTableCell } from '../../custom/table';
import { getWidthColumnByPercent } from '../../lib/components/function';

/* Sagas Action */
import { buildWBoundActions } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

import { safeDeepGetWithType, safeDeepGet } from 'iotera-base/json';
import { _N, isEmpty } from 'iotera-base/object';
import uuid from 'uuid';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const uuidv1 = require('uuid/v1');

const ADD = "ADD";
const WKEY = "RULE_CREATE_EDITOR";
const wBoundActions = buildWBoundActions(WKEY);

class RuleCreateAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentAction: {},
      initAction: this.props.infoTask
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const domainIsTenant = dit(_props);
    const domains = domain(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wSetConfig({
      single_config: {
        [ADD]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/rule/add"
          },
          wcallback: {
            finished: function (id, result) {
              _this.setState({ loading: false })
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  // Magic to refresh routes
                  _props.history.push('..')
                  _props.history.push('../../_rule_list_')
                  _props.showSingleNotification({ message: 'Tambah rule sukses', level: 'success' });
                  return;
                }
              }
              _props.showSingleNotification({ message: 'Tambah rule gagal', position: 'tr', level: 'error' });
            }
          },
          wreducer: {
            enable: false
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _props = this.props
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  handleSubmit() {
    const _this = this;
    const _props = _this.props;
    const body = {
      ...safeDeepGet(_props, ['info'], {}),
      condition: safeDeepGet(_props, ['trigger'], {}),
      trigger: safeDeepGet(_props, ['trigger'], {}),
      action: safeDeepGet(_props, ['action'], {})
    };
    _props.wSingleRequestCall({
      id: ADD,
      body
    });
  }

  handleCancel() {
    this.props.history.goBack();
  }

  handleAddTask() {
    this.props.history.push('.' + S + 'action' + S + 'task');
  }

  render() {
    // Check if info is empty
    const _this = this;
    const _props = _this.props;
    const _state = _this.state
    const info = safeDeepGet(_props, ['info'], {});
    if (isEmpty(info)) {
      _props.history.replace('.' + S + 'info');
    }
    const currentAction = safeDeepGet(_props, ['action'], {});
    const currentActionSize = Object.keys(currentAction).length;
    return (
      <div className="view">
        <SubViewHeaderStep title='Tambah Rule'
          subTitle='Rule Action'
          steps={['Info', 'Trigger', 'Action']}
          activeStep={2} />
        <div className="io-container mt-12" >
          <SizeMe>{({ size }) => <div>
            {currentActionSize > 0 &&
              <div>
                <Table className="table">
                  <TableHead style={{ height: 0 }}>
                    <TableRow>
                      <CustomTableCell style={{
                        minWidth: getWidthColumnByPercent(70, size.width - 140),
                        maxWidth: getWidthColumnByPercent(100, size.width - 140)
                      }}>
                        Name
                      <CustomTableCell style={{
                          minWidth: getWidthColumnByPercent(20, size.width - 140),
                          maxWidth: getWidthColumnByPercent(30, size.width - 140)
                        }}>
                        </CustomTableCell>
                      </CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(currentAction).map((key) =>
                      <TableRow key={key} className='table-row-child-iotera'>
                        <TableCell >
                          {currentAction[key]['name']}
                        </TableCell>
                        <TableCell>
                          <UncontrolledDropdown onMouseOver={(e) => {
                            const optionOpen = safeDeepGetWithType(_state, ['optionOpen'], {});
                            optionOpen[key] = true;
                            _this.setState({ optionOpen: { ...optionOpen } });
                          }} onMouseLeave={(e) => {
                            const optionOpen = safeDeepGetWithType(_state, ['optionOpen'], {});
                            optionOpen[key] = false;
                            _this.setState({ optionOpen: { ...optionOpen } });
                          }} isOpen={safeDeepGetWithType(_state, ['optionOpen', key], false)} style={{ cursor: 'pointer' }}>
                            <DropdownToggle tag="div">
                              <MoreIcon color="inherit" style={{ height: 30, width: 30 }} />
                            </DropdownToggle>
                            <DropdownMenu style={{ padding: 0, margin: 0 }}>
                              <DropdownItem style={{ margin: 0 }} onClick={(e) => { _this.handleEdit(key) }}>
                                <EditIcon color="inherit" style={{ height: 18, width: 18 }} />
                                &emsp;<span style={{ marginRight: 20 }}>Edit</span>
                              </DropdownItem>
                              <DropdownItem style={{ margin: 0 }} onClick={(e) => { _this.handleDelete(key) }}>
                                <DeleteIcon color="inherit" style={{ height: 18, width: 18 }} />
                                &emsp;<span style={{ marginRight: 20 }}>Hapus</span>
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </div>}
            <div className="button-right">
              <Button variant="outlined"
                type="button"
                size="large"
                style={{ minWidth: '0%' }}
                onClick={(e) => { _this.handleAddTask() }} >Tambah Action</Button>
            </div>
          </div>
          }
          </SizeMe>
          <br />
          <div className="button-right">
            <Button variant="outlined"
              type="button"
              size="large"
              style={{ minWidth: '0%' }}
              onClick={(e) => { _this.handleCancel() }} >Kembali</Button>
            <Button variant="contained"
              size="large"
              color="primary"
              type="submit"
              style={{ marginLeft: 10, minWidth: '0%' }}
              onClick={(e) => { _this.handleSubmit() }} >Kirim</Button>
          </div>
        </div>
      </div >
    )
  }
}

const mapStateToProps = function (state) {
  return {
    info: safeDeepGetWithType(state, ['rule', 'create_info'], {}),
    trigger: safeDeepGetWithType(state, ['rule', 'create_trigger'], {}),
    action: safeDeepGetWithType(state, ['rule', 'create_action'], {})
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(ruleActions, dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RuleCreateAction));